import type { Command } from "../types.ts";

export const theme: Command = {
  name: "theme",
  aliases: ["color", "colour"],
  description: "Change the color palette. Try: /theme list",
  usage: "/theme [name|list]",
  run(ctx) {
    const list = ctx.term.listThemes();
    const arg = (ctx.args[0] ?? "").toLowerCase();

    if (!arg || arg === "list") {
      ctx.printHTML(`<span class="label">palettes</span> <span class="c-muted">— /theme &lt;name&gt;</span>`);
      const active = document.documentElement.dataset.theme;
      for (const t of list) {
        const mark = t.id === active ? `<span class="c-ok">●</span>` : `<span class="c-dim">○</span>`;
        const swatch =
          `<span class="swatch" style="background:${t.vars.accent}"></span>` +
          `<span class="swatch" style="background:${t.vars.accent2}"></span>` +
          `<span class="swatch" style="background:${t.vars.bg};border:1px solid ${t.vars.border}"></span>`;
        ctx.printHTML(
          `  ${mark} <span class="c-accent">${pad(t.id, 11)}</span> ${swatch} <span class="c-muted">${esc(
            t.label,
          )}</span>`,
        );
      }
      return;
    }

    if (ctx.term.setTheme(arg)) {
      ctx.printHTML(`theme set to <span class="c-accent">${esc(arg)}</span> <span class="c-muted">(saved)</span>`);
    } else {
      ctx.printHTML(`<span class="c-warn">no such theme:</span> ${esc(arg)} — try <span class="c-accent">/theme list</span>`);
    }
  },
};

function pad(s: string, n: number): string {
  return esc(s).padEnd(n, " ").replace(/ /g, "&nbsp;");
}
function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
